const IncomeActivationConfig = [
  {
    name: "staticNote",
    label: "Note",
    type: "staticTextBold",
    value:
      "Complete the items below to begin taking lifetime withdrawals from your Allianz Lifetime Income+ Annuity.",
  },
  {
    name: "staticNote2",
    label: "Note",
    type: "staticText",
    value:
      "Your annuity is going to be transferred to Allianz via a tax-free rollover to an IRA.  Statements for this annuity will come directly from Allianz each year and you will be able to access your account from their website 24/7/365.",
  },
  {
    name: "frequency",
    label: "Income Frequency",
    type: "select",
    options: ["Monthly", "Quarterly", "Semi-Annually", "Annually"],
    required: true,
    tooltip: "The interval frequency is based on your birthday.",
  },
  {
    name: "start",
    label: "Income Start",
    type: "select",
    options: ["Next Birthday", "Now", "SpecifyDate"],
    required: true,
    tooltip:
      "Please note that on your birthday the benefit base will be reset (and likely increase) so it may be in your best interest to wait until then.",
    conditionalFields: {
      SpecifyDate: [
        {
          name: "incomeStartDate",
          label: "Income Start Date",
          type: "date",
          required: true,
        },
      ],
    },
  },
  {
    name: "factorName",
    label:
      "Lifetime income to be elected?(If electing Joint , person must be your spouse)",
    type: "radio",
    options: ["Single", "Joint"],
    required: true,
    conditionalFields: {
      Joint: [
        {
          name: "jointFirstName",
          label: "Spouse First Name",
          type: "text",
          required: true,
          maxLength: 100,
          validator: "normalText",
        },
        {
          name: "jointMiddleInitial",
          label: "Spouse MI",
          type: "text",
          required: false,
          maxLength: 1,
          validator: "normalText",
        },
        {
          name: "jointLastName",
          label: "Spouse Last Name",
          type: "text",
          required: true,
          maxLength: 100,
          validator: "normalText",
        },
        {
          name: "jointSSN",
          label: "Spouse SSN",
          type: "text",
          required: true,
          validator: "ssn",
          maxLength: 11,
        },
        {
          name: "jointDOB",
          label: "Spouse Date of Birth",
          type: "date",
          required: true,
        },
        {
          name: "jointGender",
          label: "Gender",
          type: "radio",
          options: ["Male", "Female"],
          required: true,
        },
        {
          name: "fileUpload1",
          label: "Spouse Proof Of Age Document Upload",
          type: "file",
          required: true,
        },
        {
          name: "addressSame",
          label: "Address is same as yours",
          type: "radio",
          options: ["Yes", "No"],
          required: true,
          conditionalFields: {
            No: [
              {
                name: "spouseAddressLine1",
                label: "Address Line1",
                type: "text",
                required: true,
                maxLength: 100,
              },
              {
                name: "spouseAddressLine2",
                label: "Address Line2",
                type: "text",
                required: true,
                maxLength: 100,
              },
              {
                name: "spouseAddressCity",
                label: "City",
                type: "text",
                required: true,
                maxLength: 100,
              },
              {
                name: "spouseAddressState",
                label: "State",
                type: "select",
                required: true,
                options: [
                  "Armed Forces America",
                  "Armed Forces",
                  "Armed Forces Pacific",
                  "Alaska",
                  "American Samoa",
                  "Alabama",
                  "Arkansas",
                  "Arizona",
                  "California",
                  "Colorado",
                  "Connecticut",
                  "District of Columbia",
                  "Delaware",
                  "Florida",
                  "Georgia",
                  "Guam",
                  "Hawaii",
                  "Iowa",
                  "Idaho",
                  "Illinois",
                  "Indiana",
                  "Kansas",
                  "Kentucky",
                  "Louisiana",
                  "Massachusetts",
                  "Maryland",
                  "Maine",
                  "Michigan",
                  "Minnesota",
                  "Missouri",
                  "Mississippi",
                  "Montana",
                  "North Carolina",
                  "North Dakota",
                  "Nebraska",
                  "New Hampshire",
                  "New Jersey",
                  "New Mexico",
                  "Nevada",
                  "New York",
                  "Northern Mariana Islands",
                  "Ohio",
                  "Oklahoma",
                  "Oregon",
                  "Pennsylvania",
                  "Puerto Rico",
                  "Rhode Island",
                  "South Carolina",
                  "South Dakota",
                  "Tennessee",
                  "Texas",
                  "Utah",
                  "Virginia",
                  "Vermont",
                  "Virgin Islands",
                  "Washington",
                  "Wisconsin",
                  "West Virginia",
                  "Wyoming",
                ],
              },
              {
                name: "spouseAddressZip",
                label: "Zip Code",
                type: "text",
                required: true,
                validator: "zip",
              },
            ],
          },
        },
      ],
    },
  },
  {
    name: "fileUpload2",
    label: "Participant Proof Of Age Document Upload",
    type: "file",
    required: true,
  },
  {
    name: "paymentLocation",
    label: "Payment Location",
    type: "radio",
    options: ["ACH", "Check to Address of Record"],
    required: true,
    conditionalFields: {
      ACH: [
        {
          name: "bankName",
          label: "Bank Name",
          type: "text",
          required: true,
          maxLength: 100,
          validator: "normalText",
        },
        {
          name: "accountType",
          label: "Account Type",
          type: "select",
          options: ["Checking", "Savings"],
          required: true,
        },
        {
          name: "routingNumber",
          label: "Routing Number",
          type: "text",
          required: true,
          validator: "routingNumber",
        },
        {
          name: "accountNumber",
          label: "Account Number",
          type: "text",
          required: true,
          validator: "accountNumber",
        },
        {
          name: "accountHolder",
          label: "Account Holder Name(s)",
          type: "text",
          required: true,
          maxLength: 100,
          validator: "normalText",
        },
      ],
    },
  },
  {
    name: "beneficiaries",
    label: "Beneficiaries",
    type: "repeatingSection",
    fields: [
      {
        name: "beneficiaryType",
        label: "Beneficiary Type",
        type: "radio",
        options: ["Primary", "Contingent"],
        required: true,
      },
      {
        name: "percentage",
        label: "Percentage",
        type: "number",
        required: true,
      },
      {
        name: "category",
        label: "Category",
        type: "select",
        options: ["Individual", "Company", "Trust"],
        required: true,
        conditionalFields: {
          Individual: [
            {
              name: "relationship",
              label: "Relationship",
              type: "select",
              options: [
                "Aunt",
                "Child",
                "Business Partner",
                "Child-in-law",
                "Cousin",
                "Daughter",
                "Domestic Partner",
                "Estate",
                "Fiance",
                "Friend",
                "Granddaughter",
                "Grandfather",
                "Grandmother",
                "Grandson",
                "Guardian",
                "Nephew",
                "Parent",
                "Sibling",
                "Sister",
                "Son",
                "Spouse",
                "Uncle",
              ],
              required: true,
            },
            {
              name: "firstName",
              label: "First Name",
              type: "text",
              required: true,
              maxLength: 100,
              validator: "normalText",
            },
            {
              name: "lastName",
              label: "Last Name",
              type: "text",
              required: true,
              maxLength: 100,
              validator: "normalText",
            },
            {
              name: "birthdate",
              label: "Birthdate",
              type: "date",
              required: true,
            },
            {
              name: "ssn",
              label: "SSN",
              type: "text",
              required: true,
              validator: "ssn",
            },
          ],
          Company: [
            {
              name: "entityName",
              label: "Entity Name",
              type: "text",
              required: true,
              maxLength: 100,
            },
          ],
          Trust: [
            {
              name: "entityName",
              label: "Entity Name",
              type: "text",
              required: true,
              maxLength: 100,
            },
            {
              name: "trustType",
              label: "Trust Type",
              type: "select",
              options: [
                "Family Trust",
                "Revocable Trust",
                "Irrevocable Trust",
                "Charitable Lead Trust",
                "Charitable Remainder Trust",
                "Other",
              ],
              required: true,
            },
          ],
        },
      },
    ],
  },
];

export default IncomeActivationConfig;
